import styled from 'styled-components'

export const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

export const styles = {
  main: {
    minHeight: '100vh',
    backgroundColor: 'white'
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  root: {
    flexGrow: 1
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 12
  },
  userButton: {
    marginLeft: 12,
    marginRight: -12
  },
  upload: {
    borderRadius: '10%',
    width: '60px',
    height: '60px',
    fontSize: '44px'
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100vw',
    marginTop: '0px'
  },
  button: {
    margin: '0px 20px 20px 20px',
    width: '90%',
    maxWidth: '500px'
  }
}



// WEBPACK FOOTER //
// ./src/pages/Document/styles.js